<div class="dropdown-menu" cignaHoverDropdown>
  <button
    class="menu-button"
    cignaButton="link"
    style="padding-right: 0 !important; padding-left: 0 !important"
    [attr.data-test-id]="dataTest ? dataTest : 'dropdown-menu-button'"
    [attr.aria-label]="shouldHideMenuLabel ? menuLabel : undefined"
  >
    <ng-container *ngIf="menuLabel && !shouldHideMenuLabel">
      {{ menuLabel }}</ng-container
    >

    <ng-container *ngIf="iconName">
      <ng-leaf-icon-next
        [name]="iconName"
        category="system"
        weight="regular"
        size="24"
      ></ng-leaf-icon-next>
    </ng-container>

    <cigna-icon-triangle
      size="medium"
      color="blue"
      direction="south"
      style="height: 5px; display: inline-flex"
    ></cigna-icon-triangle>
  </button>

  <div
    class="dropdown-content"
    data-test-id="dropdown-content"
    [style.width.px]="dropdownWidth"
    #dropdownMenu
  >
    <ng-content></ng-content>
  </div>
</div>
